import { render, staticRenderFns } from "./addRequires.vue?vue&type=template&id=78b2c2d9"
import script from "./addRequires.vue?vue&type=script&lang=js"
export * from "./addRequires.vue?vue&type=script&lang=js"
import style0 from "./addRequires.vue?vue&type=style&index=0&id=78b2c2d9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports